import { useQuery } from '@tanstack/react-query';
import { getQCReportImages } from '@/app/assets/actions/rapidModel';

export const RAPID_MODEL_RENDERS_QUERY_KEY = 'rapidModelRenders';

export function useRapidModelRendersQuery(id: number) {
  return useQuery({
    queryKey: [RAPID_MODEL_RENDERS_QUERY_KEY, id],
    queryFn: async () => {
      return await getQCReportImages(id);
    },
    throwOnError: false,
  });
}
